import { createRouter, createWebHistory } from 'vue-router'
import OpenningPage from '@/views/OpenningPage/index.vue'
import showLoginOrRegPopup from '@a/components/showLoginOrRegPopup'
import { useUserInfo } from '@/store'
import GooglePage from '@/views/google/index.vue'
import MaintainPage from '@/views/Maintain/index.vue'
import LoginPage from '@/components/Login/index.vue'
import RegPage from '@/components/Reg/index.vue'
const router = createRouter({
  history: createWebHistory(),
  routes: [{
    path: '/login', name: 'login', component: LoginPage
  }, {
    path: '/reg', name: 'reg', component: RegPage
  }, {
    path: '/template', name: 'template', component: GooglePage
  }, {
    path: '/maintain', name: 'maintain', component: MaintainPage
  }, {
    path: '/:pathMatch(.*)*', name: 'openning', component: OpenningPage
  }]
})

const needLogin = ['giftcode', 'agentcenter']

router.beforeEach((to, from, next) => {
  if (useUserInfo().isLoggedin) {
    if (to.path === '/login' || to.path === '/reg') {
      console.warn('already login')
      next({ path: '/home', replace: true })
    } else next()
  } else {
    const needCheckLogin = to.meta.needLogin || needLogin.includes(to.params.type as string)
    if (needCheckLogin) {
      if (from.path === to.path || to.path == '/meu') {
        next({ path: '/login' })
      } else {
        showLoginOrRegPopup()
      }
    } else next()
  }
})

export default router
